<template>
    <div class="aside aside-left aside-fixed d-flex flex-column flex-row-auto user-select-none" id="kt_aside">
        <div class="brand flex-column-auto" id="kt_brand">
            <a :href="$route('dashboard')" class="brand-logo">
                <img alt="Logo" src="/images/ybd_b2b.png" class="h-30px"/>
            </a>
            <button class="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
            <span class="svg-icon svg-icon svg-icon-xl">
                <svg width="24px" height="24px" viewBox="0 0 24 24">
                    <g id="Stockholm-icons-/-Text-/-Text-width" stroke="none" stroke-width="1" fill="none"
                       fill-rule="evenodd">
                        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M22 11.5C22 12.3284 21.3284 13 20.5 13H3.5C2.6716 13 2 12.3284 2 11.5C2 10.6716 2.6716 10 3.5 10H20.5C21.3284 10 22 10.6716 22 11.5Z"
                              fill="black"/>
                        <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd"
                              d="M14.5 20C15.3284 20 16 19.3284 16 18.5C16 17.6716 15.3284 17 14.5 17H3.5C2.6716 17 2 17.6716 2 18.5C2 19.3284 2.6716 20 3.5 20H14.5ZM8.5 6C9.3284 6 10 5.32843 10 4.5C10 3.67157 9.3284 3 8.5 3H3.5C2.6716 3 2 3.67157 2 4.5C2 5.32843 2.6716 6 3.5 6H8.5Z"
                              fill="black"/>
                    </g>
                </svg>
            </span>
            </button>
        </div>
        <div class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
            <div id="kt_aside_menu" class="aside-menu mb-4" data-menu-vertical="1" data-menu-scroll="1"
                 data-menu-dropdown-timeout="500">
                <ul class="menu-nav pt-2">
                    <MenuItem v-if="hasMorphedEntries"
                              :url="$route('user.unmorph')"
                              route-name="user.unmorph"
                              icon="fas fa-undo-alt"
                              :label="__('actions.back_to') + ' ' + previousMorphObject.user.name"
                    />
                    <MenuItem v-if="hasMorphedAgnecy"
                              :url="$route('agency.unmorph')"
                              route-name="agency.unmorph"
                              icon="fas fa-undo-alt"
                              :label="__('actions.agency.unmorph')"
                    />

                    <UserInfoSection :user="currentUser"/>

                    <MenuItem :url="$route('dashboard')"
                              route-name="dashboard"
                              icon="fas fa-columns"
                              :label="__('navigation.dashboard')"
                    />
                    <MenuItem :url="$route('orders.index')"
                              route-name="orders.index.store"
                              icon="fas fa-exchange-alt"
                              :label="__('navigation.orders')"
                    />
                    <MenuItem v-if="Permission.SUBMIT_BRAND_PRODUCTS"
                              :url="$route('brands.product-import.overview')"
                              route-name="brands.product-import.overview"
                              icon="fas fa-upload"
                              :label="__('navigation.product_data')"
                    />
                    <MenuItem v-if="Permission.SUBMIT_BRAND_PRODUCTS"
                              :url="$route('brands.index', { owned: Permission.MANUFACTURER})"
                              route-name="brands.index"
                              icon="fas fa-cube"
                              :label="__('general.brands')"
                    />
                    <!--                    Hier fehlen noch ausschließende Permissions @unless... -->
                    <MenuItem v-if="Permission.VIEW_OWN_SUBSCRIPTIONS"
                              :url="$route('subscriptions')"
                              route-name="subscriptions"
                              icon="fas fa-redo"
                              :label="__('general.subscription')"
                    />
                    <MenuItem :url="$route('company')"
                              route-name="company"
                              icon="fas fa-city"
                              :label="__('general.company_details')"
                    />
                    <MenuSection v-if="Permission.OWN_STORES" :label="__('navigation.your_stores')"/>
                    <MenuItem
                        v-if="Permission.OWN_STORES"
                        :url="$route('stores.index')"
                        route-name="stores.index"
                        icon="fas fa-store"
                        :label="__('navigation.your_stores')"
                    />
                    <MenuItem
                        v-if="Permission.OWN_STORES"
                        :url="$route('stores.create')"
                        route-name="stores.create"
                        icon="fas fa-plus-circle"
                        :label="__('navigation.create_store')"
                    />
                    <MenuItem v-if="Permission.OWN_STORES && currentUser.agency_id === 1"
                              :url="$route('store-settings.create')"
                              route-name="store-settings.create"
                              icon="fas fa-external-link-alt"
                              :label="__('navigation.store-settings')"
                              :locked-text="__('locked.basic')"
                    />
                    <CollapsableMenu
                        v-if="Permission.OWN_STORES"
                        icon="fas fa-boxes"
                        :label="__('navigation.products')"
                        :locked-text="__('locked.basic')"
                    >
                        <CollapsableMenuItem
                            :url="$route('article.redirect-to-store')"
                            route-name="article.redirect-to-store"
                            :label="__('navigation.index_article')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('article.create')"
                            route-name="article.create"
                            :label="__('navigation.create_article')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('article.update.show')"
                            route-name="article.update.show"
                            :label="__('navigation.update_article')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('ftp.account.settings')"
                            route-name="ftp.account.settings"
                            icon="fas fa-server"
                            :label="__('navigation.ftp_settings')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('ftp.connector.settings')"
                            route-name="ftp.connector.settings"
                            :label="__('navigation.connector_settings')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('stocks.upload')"
                            route-name="stocks.upload"
                            :label="__('navigation.stock_upload')"
                            :locked-text="__('locked.premium')"
                        ></CollapsableMenuItem>
                    </CollapsableMenu>
                    <MenuItem v-if="Permission.OWN_STORES && ['de', 'at'].indexOf($lang.locale) > -1"
                              :url="$route('reservations')"
                              route-name="reservations"
                              icon="fas fa-business-time"
                              :label="__('navigation.reservations')"
                    />
                    <MenuItem v-if="Permission.OWN_STORES && ['de', 'at'].indexOf($lang.locale) > -1"
                              :url="$route('offers')"
                              route-name="offers"
                              icon="fas fa-list-alt"
                              :label="__('navigation.offers')"
                    />
                    <MenuItem
                        v-if="Permission.OWN_STORES"
                        :url="$route('statistics')"
                        route-name="statistics"
                        icon="fas fa-chart-bar"
                        :label="__('navigation.stats')"
                    />
                    <MenuItem
                        v-if="Permission.OWN_STORES"
                        :url="$route('orders.statistics.overview')"
                        route-name="orders.statistics.overview"
                        icon="fas fa-chart-pie"
                        :label="__('orders.statistics')"
                    />
                    <MenuItem
                        v-if="Permission.OWN_STORES"
                        :url="$route('integrations.index')"
                        route-name="integrations.index"
                        icon="fas fa-link"
                        :label="__('navigation.integrations')"
                    />

                    <!-- ADMIN SECTION -->
                    <MenuSection v-if="Permission.ACCESS_ADMIN_PANEL" label="Administration"
                                 icon="fas fa-lock text-light"/>
                    <CollapsableMenu
                        v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_ALL_STORES"
                        icon="fas fa-city"
                        :label="__('navigation.all_stores')"
                    >
                        <CollapsableMenuItem
                            :url="$route('store.index.all')"
                            route-name="store.index.all"
                            :label="__('navigation.all_stores')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('stores.groups')"
                            route-name="stores.groups"
                            :label="__('navigation.store_groups')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            v-if="Permission.CREATE_STORE"
                            :url="$route('admin.stores.create')"
                            route-name="admin.stores.create"
                            :label="__('navigation.create_store')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            v-if="Permission.EDIT_CONNECTORS"
                            :url="$route('connectors.index')"
                            route-name="connectors.index"
                            :label="__('navigation.connectors')"
                        ></CollapsableMenuItem>
                    </CollapsableMenu>
                    <MenuItem
                        v-if="Permission.ACCESS_ADMIN_PANEL"
                        :url="$route('orders.index.all')"
                        route-name="orders.index.all"
                        icon="fas fa-exchange-alt"
                        :label="__('navigation.all_orders')"
                    />
                    <MenuItem v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_BRANDS"
                              :url="$route('brands.index', { owned: Permission.MANUFACTURER})"
                              route-name="brands.index"
                              icon="fas fa-cube"
                              :label="__('general.brands')"
                    />
                    <CollapsableMenu
                        v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_REPORTS"
                        icon="fas fa-search"
                        :label="__('navigation.reports')"
                    >
                        <CollapsableMenuItem
                            :url="$route('reports.google')"
                            route-name="reports.google"
                            :label="__('navigation.merchants')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('reports.lia')"
                            route-name="reports.lia"
                            :label="__('navigation.lia')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            :url="$route('reports.last-feed-upload')"
                            route-name="reports.last-feed-upload"
                            :label="__('navigation.last_feed_uploads')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            v-if="Permission.VIEW_YOUBUYDA_SALES_REPORTS"
                            :url="$route('reports.sales')"
                            route-name="reports.sales"
                            :label="__('navigation.sales')"
                        ></CollapsableMenuItem>
                    </CollapsableMenu>
                    <CollapsableMenu
                        v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_ALL_USERS"
                        icon="fas fa-users"
                        :label="__('navigation.users')"
                    >
                        <CollapsableMenuItem
                            :url="$route('users')"
                            route-name="users"
                            :label="__('navigation.users')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            v-if="Permission.INVITE_USERS"
                            :url="$route('users.invitations')"
                            route-name="users.invitations"
                            :label="__('navigation.invitations')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            v-if="Permission.INVITE_USERS && currentUser.agency_id !== 1"
                            :url="$route('agency.links', { agencyId: currentUser.agency_id })"
                            route-name="agency.links"
                            :label="__('general.registration_links')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            v-if="Permission.VIEW_USER_ROLES"
                            :url="$route('user.roles')"
                            route-name="user.roles"
                            :label="__('navigation.roles')"
                        ></CollapsableMenuItem>
                        <CollapsableMenuItem
                            v-if="Permission.VIEW_ALL_SUBSCRIPTIONS"
                            :url="$route('subscriptions.all')"
                            route-name="subscriptions.all"
                            :label="__('general.subscriptions')"
                        ></CollapsableMenuItem>
                    </CollapsableMenu>
                    <MenuItem v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_ALL_USER_REQUESTS"
                              :url="$route('user.requests.index')"
                              route-name="user.requests.index"
                              icon="fas fa-envelope-open-text"
                              :label="__('navigation.all_requests')"
                              badge="$pendingUserRequests ?? 'n/a'"
                              badgeId="badgePur"
                    />
                    <MenuItem v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_ALL_FTP_ACCOUNTS"
                              :url="$route('ftp.accounts')"
                              route-name="ftp.accounts"
                              icon="fas fa-server"
                              :label="__('navigation.ftp_accounts')"
                    />
                    <MenuItem v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_USER_REPORTS"
                              :url="$route('user-reports')"
                              route-name="user-reports"
                              icon="fas fa-exclamation-triangle"
                              :label="__('navigation.user_reports')"
                    />
                    <MenuItem v-if="Permission.ACCESS_ADMIN_PANEL && Permission.VIEW_ALL_AGENCIES"
                              :url="$route('agencies')"
                              route-name="agencies"
                              icon="fas fa-user-secret"
                              :label="__('agency.agencies')"
                    />
                    <MenuItem v-if="Permission.ACCESS_ADMIN_PANEL"
                              :url="'/app/integrations/admin'"
                              route-name="integrations.admin.overview"
                              icon="fas fa-link"
                              :label="__('navigation.integrations') + ' manager'"
                    />
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import MenuItem from '@components/Navigation/Menu/MenuItem.vue'
import {PermissionsMixin} from '@js/permissions'
import MenuSection from '@components/Navigation/Menu/MenuSection.vue'
import CollapsableMenu from '@components/Navigation/Menu/CollapsableMenu.vue'
import CollapsableMenuItem from '@components/Navigation/Menu/CollapsableMenuItem.vue'
import UserInfoSection from '@components/Navigation/Menu/UserInfoSection.vue'

export default {
    components: {UserInfoSection, CollapsableMenuItem, CollapsableMenu, MenuItem, MenuSection},

    mixins: [PermissionsMixin],

    props: {
        title: String,
    },

    computed: {
        currentUser() {
            return this.$page.props.user
        },

        hasMorphedEntries() {
            return this.$page.props.has_morphed_entries
        },

        hasMorphedAgnecy() {
            return this.$page.props.has_morphed_agency
        },

        previousMorphObject() {
            return this.$page.props.previous_morph_object
        }
    },
}
</script>
